<div class="container">
    <ng-content select="span[fcpDragHandle]"></ng-content>
    <div
        *ngIf="showActionsIcon"
        class="card-actions"
        (mouseenter)="showActionsMenu(true)"
        (mouseleave)="showActionsMenu(false)"
    >
        <fcp-icon class="card-actions-icon" [icon]="['fal', 'ellipsis']"></fcp-icon>
        <div class="card-action-space"></div>
        <div
            (mouseenter)="showActionsMenu(true)"
            (mouseleave)="showActionsMenu(false)"
            class="card-actions-menu"
            [ngClass]="{ 'card-actions-menu-appear': (showActions | async) }"
        >
            <div
                *ngFor="let action of properties.actionsList"
                (click)="callAction(action.key)"
                class="card-actions-button"
            >
                <label>
                    {{ action.label }}
                </label>
            </div>
        </div>
    </div>

    <div class="card-cover-container" (click)="onClick()">
        <div *ngIf="properties.variant === getCardVariant('CREATE')" class="card-create">
            <fcp-icon
                [icon]="properties.icon"
                [style]="'color:var(--text-11);font-size:var(--text-size-4xl)'"
            ></fcp-icon>
            <label>{{ properties.label }}</label>
        </div>
        <div *ngIf="properties.variant === getCardVariant('COVER')" class="card">
            <div class="card-cover" [ngStyle]="{ 'background-image': 'url(' + properties.coverImg + ')' }"></div>
        </div>
        <div *ngIf="properties.variant === getCardVariant('NO_COVER')" class="card">
            <div class="card-cover card-no-cover-img-container">
                <div
                    class="card-no-cover-img"
                    *ngFor="let img of properties.imageList; let i = index"
                    [ngStyle]="{
                        'background-image': img ? 'url(' + img + ')' : 'none',
                        'background-color': img ? 'transparent' : 'var(--light-disabled-bg)'
                    }"
                    [ngClass]="{ 'margin-bottom-right': i === 0, 'margin-left': i === 3 }"
                ></div>
            </div>
        </div>
        <div *ngIf="properties.variant === getCardVariant('EMPTY_COVER')" class="card">
            <div class="card-cover" [ngStyle]="{ 'background-image': 'url(' + properties.coverImg + ')' }">
                <div class="card-cover-overlay">
                    <label>{{ properties.imgLabel }}</label>
                </div>
            </div>
        </div>
        <div *ngIf="properties.variant === getCardVariant('EMPTY_NO_COVER')" class="card">
            <div class="card-cover" [ngStyle]="{ 'background-color': 'var(--interactive-30)' }">
                <div class="card-cover-overlay">
                    <label>{{ properties.imgLabel }}</label>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="properties.variant !== getCardVariant('CREATE')" class="card-label">
        <label>{{ properties.label }}</label>
    </div>
</div>
